/* eslint no-console:0 */

import 'css/landing';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

import Rails from '@rails/ujs';

Rails.start();

const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)')

if (reducedMotion && reducedMotion.matches) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-autoplay-demo]').forEach((video) => {
      video.removeAttribute('autoplay')
      video.pause()
    })
  })
}
